module.exports = __webpack_public_path__ + "static/media/clock.286e20a1.svg";